import { Route, Routes } from "react-router-dom";
import RusaDashboard from "./UnivDataComponents/Dashboard";
import MainDashboard from "./UnivDataComponents/MainDashboard";
import MenuBar from "./UnivDataComponents/MenuBar";
// import Test from "./Test";
import RequireAuth from "./RequireAuth";
import Unauthorized from "./Unauthorized";
import Status from "./CommonUtils/ESIGN/Status";
import Home from "./LoginComponents/Home";
import Aboutpage from "./LoginComponents/Aboutpage";
import Login from "./LoginComponents/Login";
import ServiceUnavailable from "./LoginComponents/ServiceUnAvailable";
import NewsEvents from "./KapuServices/NewsEvents";
import SlidingImages from "./KapuServices/SlidingImages";
import LatestNews from "./KapuServices/LatestNews";
import AddKeyPeople from "./KapuServices/AddKeyPeople";
import TenderNotifications from "./KapuServices/TenderNotifications";
import ContactUs from "./KapuServices/ContactUs";
import ContactPage from "./LoginComponents/ContactUs";
import TendersPage from "./LoginComponents/TendersPage";
import DownloadPage from "./LoginComponents/Downloads";
import GalleryPage from "./LoginComponents/GalleryPage";

const RoutesComponent = () => (
        <Routes>



                {/* ........STUDENT SERVICES........... */}
                <Route path="/Dashboard" element={<RusaDashboard />} />
                <Route path="/unauthorized" element={<Unauthorized />} />
                {/* <Route path="/esignresponse/Status" element={<Status />} /> */}
                <Route path="/" element={<Home />} />
                <Route path="/homee" element={<Home />} />
                <Route path="/about" element={<Aboutpage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/ContactPage" element={<ContactPage />} />
                <Route path="/TendersPage" element={<TendersPage />} />
                <Route path="/DownloadPage" element={<DownloadPage />} />
                <Route path="/GalleryPage" element={<GalleryPage />} />
                {/* <Route element={<RequireAuth />}> */}

                <Route path="/home" element={<MenuBar><MainDashboard /></MenuBar>} />
                <Route path="*" element={<MenuBar><ServiceUnavailable /></MenuBar>} />

                <Route path="/News & Events" element={<MenuBar><NewsEvents /></MenuBar>} />
                <Route path="/sliding images" element={<MenuBar><SlidingImages /></MenuBar>} />
                <Route path="/Latest news" element={<MenuBar><LatestNews /></MenuBar>} />
                <Route path="/Add Key People" element={<MenuBar><AddKeyPeople /></MenuBar>} />
                <Route path="/Tender Notifications" element={<MenuBar><TenderNotifications /></MenuBar>} />
                <Route path="/Contact Us" element={<MenuBar><ContactUs /></MenuBar>} />




                {/* </Route> */}
        </Routes>
);

export default RoutesComponent;